import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { TeamOverview } from "../../../components/team-overview";
import Ally from "../../../images/team/ally.png";
import Amy from "../../../images/team/amy.jpg";
import Janelle from "../../../images/team/janelle.jpg";
import Kylon from "../../../images/team/kylon.png";
import Rachel from "../../../images/team/rachel.png";

export interface ITeamProps {
    sectionId: string;
    index: number;
}

export function Team(props: ITeamProps) {
    const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
    return (
        <Section
            sectionId={props.sectionId}
            isLast={false}
        >
            <SectionHeader
                title={`${formattedIndex} Meet the Team`}
            />
            <TeamOverview
            members= {
                [
                    {
                        name: "Ally Hopping",
                        picUrl: Ally,
                        portfolioUrl: "https://allyhopping.com/",
                        linkedInUrl: "https://www.linkedin.com/in/ally-hopping-1a305a58/",
                        blurb: "Ally is a product designer who aims to apply UX design principles to create positive, sustainable outcomes for people and the environment. In her free time, she enjoys running, reading and listening to music."
                    },
                    {
                        name: "Amy Zhuang",
                        picUrl: Amy,
                        portfolioUrl: "",
                        linkedInUrl: "https://www.linkedin.com/in/amyzhuang/",
                        blurb: "Amy is a product designer with a background in business and design. Fun fact: she was a pianist for almost 2 decades. Her current goal is to design experiences that help bridge the gap between people, AI, and robots."
                    },
                    {
                        name: "Janelle Wen",
                        picUrl: Janelle,
                        portfolioUrl: "https://janellewen.com",
                        linkedInUrl: "https://www.linkedin.com/in/janellewen/",
                        blurb: "Janelle is a product designer with experience in entertainment and online search. She enjoys contemporary dance, wordsmithing, and empowering others through education. She doesn't like speaking in the third-person."
                    },
                    {
                        name: "Kylon Chiang",
                        picUrl: Kylon,
                        portfolioUrl: "http://www.kylon.online",
                        linkedInUrl: "https://www.linkedin.com/in/kylon-chiang/",
                        blurb: "Kylon is an engineer by trade and an artist at heart. They love creating critical work that's a bit tongue-in-cheek. When not in front of a screen, they spend ample time in the outdoors and talk about how this is the year they will finally master watercolors."
                    },
                    {
                        name: "Rachel Arredondo",
                        picUrl: Rachel,
                        portfolioUrl: "https://rachelarre.com/",
                        linkedInUrl: "https://www.linkedin.com/in/rachelarre/",
                        blurb: "Rachel is a designer, artist, technologist with a background in literature, digital arts, and ceramics. She is interested in exploring how emerging technologies will shape our interactions, products and creative tools."
                    }
                ]
            }
            />
        </Section>
    );
}
